import { useRouteError } from 'react-router-dom';

import { ErrorState } from '@/components/ui/error-state';

/** Router-level error boundary. Rendered when any loader/action throws
 * or when a route element itself errors out. */
export function RootError(): JSX.Element {
  const err = useRouteError();
  console.error('[route-error]', err);
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <ErrorState
        title="Something went wrong"
        message="Reload to try again — if it keeps happening, sign out and back in."
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
